import { render, staticRenderFns } from "./ContactDetailForm.vue?vue&type=template&id=77af6a89&scoped=true"
import script from "./ContactDetailForm.vue?vue&type=script&lang=js"
export * from "./ContactDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77af6a89",
  null
  
)

export default component.exports